import type { Route } from 'next'

export function projectRoute(id: string): Record<string, Route> {
  return {
    show: `/iso/${id}` as Route,
  }
}
